import {Component, signal, ViewChild, WritableSignal} from '@angular/core';
import {SidebarComponent} from '@app/navigation/sidebar/sidebar.component';
import {DATA_SEARCH_FILTERS} from '@app/search/filters/data';
import {FILTERS_TOKEN} from '@app/search/filters/filter';
import {SearchBarComponent} from '@app/search/search-bar/search-bar.component';
import {DATA_SEARCH_SORT_OPTIONS, SortOption} from '@app/search/search-bar/search-bar.config';
import {SearchResultsComponent} from '@app/search/search-results/search-results.component';
import {InfiniteScrollDirective} from '@app/shared/directives/infinite-scroll.directive';
import {SearchIndexName, SearchRecordType} from '@models/search';
import {
  SectionHeaderAction,
  SectionHeaderActions,
} from '@shared/components/section-header-actions/section-header-actions';
import {TileInfo} from '@shared/types/tile-info';

@Component({
  selector: 'app-public-data-commons',
  templateUrl: './public-data-commons.component.html',
  imports: [SearchBarComponent, SidebarComponent, SearchResultsComponent],
  providers: [{provide: FILTERS_TOKEN, useValue: DATA_SEARCH_FILTERS}],
})
export class PublicDataCommonsComponent implements SectionHeaderActions {
  @ViewChild(SearchBarComponent) searchBar!: SearchBarComponent;
  @ViewChild(InfiniteScrollDirective) infiniteScrollDirective?: InfiniteScrollDirective;

  sort: SortOption[] = DATA_SEARCH_SORT_OPTIONS;
  loading = signal(false);
  tiles = signal<TileInfo[] | undefined>(undefined);
  recordType: SearchRecordType = 'projects';
  index: SearchIndexName = 'Projects';

  public sectionHeaderActions: WritableSignal<SectionHeaderAction[]> = signal([
    {
      target: '/help/public-data-commons/search',
      targetTab: '_blank',
      caption: 'Help',
      color: 'var(--mat-sys-primary)',
      icon: 'help_outline',
    },
  ]);

  async onInfiniteScroll(infiniteScroll: InfiniteScrollDirective) {
    await this.searchBar.loadNextPage();
    infiniteScroll.markLoadComplete();
  }
}
